import generateIcon from "../generateIcon";

const Table = generateIcon("fas fa-table");

export default Table;